import ff from './ff';
import cc from './cc';

import e from './e';

global.t = null; // current component, replaced at cf.myRN_stt, cleared at cf.myNV_stt_move

export default class ic extends cc { // individual constant

  static g_app_name = 'ufrs';
  static g_app_type = 'w'; // w: web, i:ios, a:android

  static g_ver = '1.0.1';

  static gb_dbg =
    (e.g_env == 'lcl') ?
      false
    : (e.g_env == 'dev') ?
      false
    : (e.g_env == 'pdn') ?
      false
    : null; 

  static gb_dev =
    (e.g_env == 'lcl') ?
      false
    : (e.g_env == 'dev') ?
      true
    : (e.g_env == 'pdn') ?
      false
    : null; 

  static g_dmn = 
    (e.g_env == 'lcl') ?
      'http://{}.localhost:19006'
    : (e.g_env == 'dev') ?
      'http://{}.data-harness.com' 
    : (e.g_env == 'pdn') ?
      'https://{}.c-supportsys.com'
    : null; 

  static g_url1 = 
    (e.g_env == 'lcl') ?
      'http://ufrsb.data-harness.com:3001/callback'
    : (e.g_env == 'dev') ?
      'http://ufrsb.data-harness.com:3001/callback'
    : (e.g_env == 'pdn') ?
      'https://ufrsb.c-supportsys.com:3001/callback'
    : null; 

  static g_url2 = 
    (e.g_env == 'lcl') ?
      'http://ufrsb.data-harness.com:3001/static'
    : (e.g_env == 'dev') ?
      'http://ufrsb.data-harness.com:3001/static'
    : (e.g_env == 'pdn') ?
      'https://ufrsb.c-supportsys.com:3001/static'
    : null; 

  static g_url3 = 
    (e.g_env == 'lcl') ?
      'http://ufrsb.data-harness.com:3001/srp'
    : (e.g_env == 'dev') ?
      'http://ufrsb.data-harness.com:3001/srp'
    : (e.g_env == 'pdn') ?
      'https://ufrsb.c-supportsys.com:3001/srp'
    : null; // for stripe

  static g_srt_key = '2iojobkamk2F_Aasiefa2iojobkamk2F_Aasiefa'; // secret key

  static g_iniPageName = 'c00v1a';
//  static g_iniPageName = 'i1zv7a';
  static g_iniPageRole = '';

  static gn_fontSizeLrg = 18; // font size large
  static gn_fontSizeNrm = 16; // font size normal
  static gn_fontSizeSml = 14; // font size small

  static gn_lmt = 100;

  static g_mail = 
    (e.g_env == 'lcl') ?
      'yukio.shinohara@data-harness.com'
    : (e.g_env == 'dev') ?
      'f-sp_ck@unitybell.co.jp'
//      'yukio.shinohara@data-harness.com'
    : (e.g_env == 'pdn') ?
      'f-sp_ck@unitybell.co.jp'
//      'yukio.shinohara@data-harness.com'
    : null; // 通知用メールアドレス

  static g_dvcMode = ( ic.gn_w > 1024 ) ? 'p' : 's'; // device mode p: pc, s: smart phone ipad pro を考慮

  static gob_menu = () => false;
  static gob_home = () => {
    if (global.t?.state.sgc_pageRole == 'own1') return 'c20v1a';
    if (global.t?.state.sgc_pageRole == 'adm1') return 'iHome1';
    if (global.t?.state.sgc_pageRole == 'mmb1') return 'iHome2';
    return null;
  };

  static g_fontCcdLrg = 'black'; // font ccd large
  static g_fontCcdNrm = 'black'; // font ccd normal
  static g_fontCcdSml = 'black'; // font ccd small

  static o_getCcd(p_type) {
    if (global.t?.state.sgcd_cmnStgs?.c01rt11i == 90) { // kanri
      if (p_type == 'd') return '#c40000'; // deep
      if (p_type == 'n') return '#f2a0a1'; // normal
      if (p_type == 'p') return '#FBE9F2'; // pale
      if (p_type == 'h') return '#fff2f2'; // hazy
      if (p_type == 't') return 'orange'; // touchable
      if (p_type == 'b') return ic.g_ccdWN; // back
      if (p_type == 'e') return '#cc2200'; // emphasis
    }
    else if (global.t?.state.sgcd_cmnStgs?.c01rt11i == 20) { // staff
      if (p_type == 'd') return '#45865B'; // deep
      if (p_type == 'n') return '#74BA52'; // normal
      if (p_type == 'p') return '#009F9F'; // pale
      if (p_type == 'h') return '#F0F7F0'; // hazy
      if (p_type == 't') return 'orange'; // touchable
      if (p_type == 'b') return ic.g_ccdWN; // back
      if (p_type == 'e') return '#cc2200'; // emphasis
    }
    else if (global.t?.state.sgcd_cmnStgs?.c01rt11i == 10) { // mmb1
      if (p_type == 'd') return '#0047AB'; // deep
      if (p_type == 'n') return '#0096FF'; // normal
      if (p_type == 'p') return '#ADD8F6'; // pale
      if (p_type == 'h') return '#F0FFFF'; // hazy
      if (p_type == 't') return 'orange'; // touchable
      if (p_type == 'b') return ic.g_ccdWN; // back
      if (p_type == 'e') return '#cc2200'; // emphasis
    }
    else { // mmb1
      if (p_type == 'd') return ic.g_ccdWN; // deep
      if (p_type == 'n') return ic.g_ccdWN; // normal
      if (p_type == 'p') return ic.g_ccdWN; // pale
      if (p_type == 'h') return ic.g_ccdWN; // hazy
      if (p_type == 't') return ic.g_ccdWN; // touchable
      if (p_type == 'b') return ic.g_ccdWN; // back
      if (p_type == 'e') return ic.g_ccdWN; // emphasis
    };
  };
  static c = (p_type) => ic.o_getCcd(p_type);

  static get_iniPageInfs(pn_roleKey) {
    if (pn_roleKey == 10) { // dantai
      return {
          sgc_pageRole: 'mmb1',
          sgc_pageName: 'iHome2',
          sgc_pageKey: '',
          sgc_pageMode: 'show',
          sgcb_pageEdt: false,
      };
    }
    if (pn_roleKey == 20) { // staff
      return {
          sgc_pageRole: 'adm1',
          sgc_pageName: 'iHome1',
          sgc_pageKey: '',
          sgc_pageMode: 'show',
          sgcb_pageEdt: false,
      };
    }
    else if (pn_roleKey == 90) { // kanri
      return {
          sgc_pageRole: 'own1',
          sgc_pageName: 'c20v1a',
          sgc_pageKey: '',
          sgc_pageMode: 'show',
          sgcb_pageEdt: false,
      };
    }
    else { // その他の場合
      alert('incorrect pageRole at get_iniPageInfs: {}'.f(pn_roleKey));
    }
  };

  static godd_menuDefss = (p_role) => { // メニュー構成, arrow-right, building, check, close, ellipsis-v, envelope, file-text, gear, pencil, plus, search, send, sign-out, sliders, tasks, th-large, th-list, th, trash, user, users

    if ( p_role == 'mmb1') return {
      i1zv1a: {
        b_vsb: true,
        type:'iconPfx', 
        iconName: 'list',
        pfx:'直接予約',
        sgc_pageRole: 'mmb1',
        sgc_pageName:'i1zv2a',
      },
      i1zv1b: {
        b_vsb: true,
        type:'iconPfx', 
        iconName: 'list',
        pfx:'エントリー',
        sgc_pageRole: 'mmb1',
        sgc_pageName:'i1zv2b',
      },
      logout: {
        b_vsb: true,
        type:'iconPfx', 
        fnc:'logout', 
        iconName: 'sign-out',
        pfx:'ログアウト',
      },
    };

    if ( p_role == 'own1') return {
      i13v1a: {
        b_vsb: true,
        type:'iconPfx', 
        iconName: 'list',
        pfx:'団体',
        sgc_pageRole: 'own1',
        sgc_pageName: 'i13v1a',
      },
      i11v1a: {
        b_vsb: true,
        type:'iconPfx', 
        iconName: 'list',
        pfx:'時間帯',
        sgc_pageRole: 'own1',
        sgc_pageName:'i11v1a',
      },
      i10v1a: {
        b_vsb: true,
        type:'iconPfx', 
        iconName: 'list',
        pfx:'室・設備',
        sgc_pageRole: 'own1',
        sgc_pageName:'i10v1a',
      },
      c60v1a: {
        b_vsb: true,
        type:'iconPfx', 
        iconName: 'list',
        pfx:'休館日',
        sgc_pageRole: 'own1',
        sgc_pageName:'c60v1a',
      },
      i1zv1a: {
        b_vsb: true,
        type:'iconPfx', 
        iconName: 'list',
        pfx:'予約',
        sgc_pageRole: 'own1',
        sgc_pageName:'i1zv1a',
      },
      i1zv1b: {
        b_vsb: true,
        type:'iconPfx', 
        iconName: 'list',
        pfx:'エントリー',
        sgc_pageRole: 'own1',
        sgc_pageName:'i1zv1b',
      },
      i1yv1a: {
        b_vsb: true,
        type:'iconPfx', 
        iconName: 'list',
        pfx:'抽選',
        sgc_pageRole: 'own1',
        sgc_pageName:'i1yv1a',
      },
      i14v1a: {
        b_vsb: true,
        type:'iconPfx', 
        iconName: 'list',
        pfx:'設定',
        sgc_pageRole: 'own1',
        sgc_pageName:'i14v1a',
      },
      logout: {
        b_vsb: true,
        type:'iconPfx', 
        fnc:'logout', 
        iconName: 'sign-out',
        pfx:'ログアウト',
      },
    };

    return {};
  };

static od_stls = () => ({
  d_rootHdrCtas: 
    (global.t?.state.sgc_pnlMode == 'list') ? 
      {
        borderWidth: 0,
        borderBottomWidth: ic.gn_bdrWNrw,
        borderColor: ic.o_getCcd('d'),
      }
    : null
  ,
  d_rootBdyCtas: 
    (global.t?.state.sgc_pnlMode == 'list') ? 
      {
        borderWidth: 0,
        borderBottomWidth: ic.gn_bdrWNrw,
        borderColor: ic.o_getCcd('d'),
      }
    : null
  ,
});

  ////////////////////////////////////////////////////////////////////////
  static b = (pn_cmn) => 
    pn_cmn * ic.gn_bdrWNrm; // convert from column to width

  static s = (pn_cmn, pb_withMgn=false) => // cc でなく ic の gn_fontSizeNrm, gn_mgnNrm を反映
    pn_cmn * ic.gn_fontSizeNrm + ((pb_withMgn == true) ? (cc.gn_mgnNrm / 2 * 2) : 0); // convert from column to width

  static m = (pn_cmn, pb_withSrlBarW=false) => 
    pn_cmn * ic.gn_mgnNrm + ((pb_withSrlBarW == true) ? ic.gn_scbW : 0); // convert from column to width

}
